import { FIREBASE } from "murflib";

export const FirebaseInstance = FIREBASE.createInstance();
